module.exports = __webpack_public_path__ + "static/media/Intro.81503391.png";